import { Role } from "modules/roles/schemas/rolesSchemas";

const getRolesDisplayNames = (roles: Array<Role | string>) => roles.join(", ");

export default getRolesDisplayNames;
